<template>
    <div class="m-portlet m-portlet--head-sm">
        <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                    <h3 class="m-portlet__head-text">
                        请假Ⅰ
                    </h3>
                </div>
            </div>
        </div>
        <div class="m-portlet__body infinite-list-wrapper" >
            <div class="m-widget4" v-infinite-scroll="load"
                 infinite-scroll-disabled="disabled">
                <div class="m-widget4__item" v-for="item in _.orderBy($parentInfo.Task_LeavingFirst.data, 'id','desc')" :key="item.id" @click="GoToStudent(item)">
                    <div class="m-widget4__left">
                        <el-tag v-if="item.status_type==1">Ⅰ</el-tag>
                        <el-tag v-else>请假</el-tag>
                    </div>
                    <div class="m-widget4__info">
                        <span class="m-widget4__title">
                            <span>{{item.name}}</span>
                        </span>
                        <span class="m-widget4__sub">
                            <div style="display: flex;flex-direction:row; justify-content:space-between">
                                <div>{{item.class_name}}</div>
                                <div>{{item.date}}</div>
                                <div>{{item.teacher_name}}</div>
                            </div>
                        </span>
                    </div>
                </div>
            </div>
            <p v-if="loading">加载中...</p>
            <p v-if="noMore">没有更多了</p>
        </div>
    </div>

</template>

<script>
    export default {
        name: "Task_LeavingFirst",
        data() {
            return {
                currentPageSize:10,
                currentPage:1,
                count:10,
                loading:false,
                waiting:false,
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$wApi.addListen(this.$parentInfo.path, this.handleData);
        },
        computed: {
            noMore () {
                return this.count === 0
            },
            disabled () {
                return this.loading || this.noMore
            }
        },
        methods: {
            GoToStudent(item){
                this.$store.dispatch('addView', {
                    'title': item.name,
                    'path': '/student/' + item.student_id,
                    'closable': true
                });
                this.router.push({path: '/student/' + item.student_id})
            },
            handleData(event,data) {
                switch (event) {
                    case 'init_leavingFirst':
                        this.count=data.total;
                        this.waiting = false;
                        this.loading = false;
                        break;
                }
            },
            load () {
                if(this.$parentInfo.task_scroll) {
                    this.loading = true
                    if (!this.waiting) {
                        this.currentPage++;
                        this.waiting = true
                        this.$wApi.send(this.$parentInfo.path, 'init_leavingFirst',
                            {'currentPageSize': this.currentPageSize,
                                'currentPage': this.currentPage,
                                'semester_id':this.$parentInfo.filter.semester_id});
                    }
                }

            }
        }
    }
</script>

<style scoped>
    .infinite-list-wrapper {
        height: 300px;
        overflow: auto;
    }
    .elements{
        display:inline-block;
        margin-right:5px;
        border-radius:25px; /* 圆形边缘弧度 */
        width:50px; /* 宽度 */
        height:20px; /* 高度 */
        border:1px solid gray ;
        text-align: center;
        color: white;
    }
</style>
